<template>
  <div
    v-loading="loading"
    @click="handtipshow"
  >
    <div class="opallbox">
      <div class="chawepalite">
        <div class="optiontext">选择平台</div>
        <el-select v-model="platformvalue" placeholder="请选择" @change="plateall">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="optionbox">
        <div class="optiontext">标题</div>
        <el-input v-model.trim="bigtitle" placeholder="请输入大标题" style="margin-right:10px" />
      </div>
    </div>
    <div class="editbox">
      <div class="centerbox">
        <el-input v-model.trim="arr[0].title" class="centerinput" placeholder="标题" style="width:235px" />

        <div style=" margin:10px 0px">
          <!-- <Editor-wang ref="editorwangfour" v-model="arr[0].content" /> -->
          <div><el-button type="primary" size="mini" @click="choosevoice">选择音频</el-button></div>

          <div v-if="editid === null || editid === undefined" class="outerLayer_mainArea">
            <div v-if=" Object.keys(voiceobj).length!=0">
              <ul class="mainArea_ul">
                <li class="ul_li">
                  <div class="li_left">
                    <span>{{ voiceobj.source_name }}</span>
                    <span>{{ voiceobj.createdAtTime.slice(0, voiceobj.createdAtTime.indexOf(' ')) }}</span>
                  </div>
                  <div class="li_right">
                    <i
                      class="right_icon el-icon-video-play"
                    />
                    <span>{{ voiceobj.duration }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-else>
            <div v-if="showvoice">
              <div class="outerLayer_mainArea">
                <div v-if=" Object.keys(voiceobj).length!=0">
                  <ul class="mainArea_ul">
                    <li class="ul_li">
                      <div class="li_left">
                        <span style="margin-top:3px">{{ voiceobj.source_name }}</span>
                      </div>
                      <div class="li_right">
                        <i
                          class="right_icon el-icon-video-play"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

            </div>

            <div v-else class="outerLayer_mainArea">
              <div v-if=" Object.keys(voiceobj).length!=0">
                <ul class="mainArea_ul">
                  <li class="ul_li">
                    <div class="li_left">
                      <span>{{ voiceobj.source_name }}</span>
                      <span>{{ voiceobj.createdAtTime.slice(0, voiceobj.createdAtTime.indexOf(' ')) }}</span>
                    </div>
                    <div class="li_right">
                      <i
                        class="right_icon el-icon-video-play"
                      />
                      <span>{{ voiceobj.duration }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>

        </div>

        <el-button type="primary" class="btne" @click="go">提交</el-button>
      </div>

    </div>
    <el-dialog title="选择音频" :visible.sync="voicedialog" append-to-body width="50%" :destroy-on-close="true">
      <voicechoose ref="voicechooseview" @voicecallback="voicecallback" />
    </el-dialog>
  </div>

</template>

<script>

import { qiniuToken } from '@/api/qiniuToken.js'
import { strategyPlatform, articleDetail } from '@/api/sourceMaterial.js'
import { addTextVoice, updateTextVoice } from '@/api/templatelist.js'
import voicechoose from './components/voicechoose.vue'
// import EditorWang from './components/AboutView.vue'
export default {

  components: {
    voicechoose
  },
  data() {
    return {
      loading: false,
      disabled: false,
      baseUrl: './',
      language: 'zh_CN',
      skin: 'oxide',
      bigtitle: '',
      arr: [
        {
          title: '', // 标题
          media_id: '', // 音频id
          media_path: '', // 音频链接
          source_name: '' // 音频名称
        }
      ],
      imgarr: [{
        img: 'https://qie-online-sale-qiniu.wsandos.com/meinv.jpg'

      }, {
        img: require('@/assets/larke/larke.png')
      }],
      options: [],

      platformvalue: null, // 选择平台
      officialaccountname: '', // 选择公众号名称
      sendata: '', // 发送日期

      indexinput: null, // 取出来的索引值

      token: null, // 七牛云token

      editor: null,
      html: '<p>hello&nbsp;world</p>',
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        excludeKeys: ['group-image', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // autoFocus: false,
        pasteFilterStyle: false,
        pasteIgnoreImg: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            customUpload: this.update
          }
        }
      },
      radiosize: 1,
      edittype: null, // false编辑 true新增
      edittyper: null,
      editid: null, // 编辑时的id
      choicedialogVisible: false,
      bookctyactivitiesVisible: false,
      redbao: false,
      sclink: false,
      dialogVisibler: false,
      chapterdialogVisibler: false,
      palarr: [],
      dialogVisible1: false,
      iframeURL: '',
      linkallarr: [],
      choserauthtype: null,
      accountpusharr: [],
      bottomarr: [],
      whichIndex: -1,
      type: 3,
      voicedialog: false,
      voiceobj: {},
      showvoice: true
    }
  },
  created(query) {
    this.getPlatform()
    console.log('query', this.$route.query)

    console.log('edittype', this.edittype)
    this.getQiniuToken()
    this.active = this.arr[0].id
    this.indexinput = 0
    this.getinforlist()
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  },
  methods: {
    // 获取详情
    async getinforlist() {
      this.editid = this.$route.query.id
      console.log('this.editid----', this.editid)
      if (this.editid === null || this.editid === undefined) {
        return
      }
      const data = await articleDetail({
        id: this.editid
      })
      console.log('获取详情-----', data)
      this.arr[0].title = data.data.articles[0].title
      this.arr[0].media_id = data.data.articles[0].media_id
      this.arr[0].media_path = data.data.articles[0].media_path
      this.arr[0].source_name = data.data.articles[0].source_name
      this.bigtitle = data.data.title
      this.platformvalue = data.data.platform_id
      this.voiceobj.source_name = data.data.articles[0].source_name
      // this.active = this.arr[0].id
      console.log('详情', data)
      this.loading = false
    },

    plateall(val) {
      console.log('val', val)
      // 清空添加链接活动数组
      this.linkallarr = []
      // eslint-disable-next-line eqeqeq
      if (val == 99) {
        console.log('通用')
      } else {
        console.log('常规')
      }
    },

    // 获取平台
    async getPlatform() {
      const data = await strategyPlatform()
      this.options = data.data.list
      console.log('获取平台', this.options)
    },
    handtipshow() {
      if (document.querySelector('.ciclebox')) { // 先判断下，不然会报错
        this.$nextTick(() => {
          this.arr.forEach(item => {
            item.showtips = false
          })
        })
      }
    },

    // 提交
    async go() {
      if (this.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.bigtitle === '') {
        this.$message.error('请输入列表标题')
        return
      }
      if (this.arr[0].title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.arr[0].media_id === '' || this.arr[0].media_path === '' || this.arr[0].source_name === '') {
        this.$message.error('请选择音频')
        return
      }
      if (this.editid === null || this.editid === undefined) {
        const data = await addTextVoice({
          title: this.bigtitle,
          type: this.type,
          platform_id: this.platformvalue,
          articles: this.arr
        })
        if (data.code === 200) {
          this.$message({
            type: 'success',
            message: '新增音频模板成功!'
          })
          this.$router.push({ path: '/offiaccountemlist/index' })
        }
      } else {
        // updateTextVoice
        const data = await updateTextVoice({
          title: this.bigtitle,
          type: this.type,
          platform_id: this.platformvalue,
          articles: this.arr,
          id: this.editid
        })
        if (data.code === 200) {
          this.$message({
            type: 'success',
            message: '音频模板修改成功!'
          })
          this.$router.push({ path: '/offiaccountemlist/index' })
        }
      }

      console.log('this.arrs', this.arr)
    },

    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },

    beforehandleCommand() {
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.$message.error('请选择子平台')
          return
        }
      } else {
        if (this.platformvalue === null) {
          this.$message.error('请选择平台')
          return
        }
      }
    },
    selectaudio() {
      console.log('audio---')
    },
    choosevoice() {
      this.voicedialog = true
      this.$nextTick(() => {
        this.$refs.voicechooseview.send()
      })
    },
    voicecallback(item) {
      this.voicedialog = false
      if (item.id) {
        this.showvoice = false
      }
      this.voiceobj = item
      console.log('音频------', item)
      this.arr[0].media_id = item.id
      this.arr[0].media_path = item.path
      this.arr[0].source_name = item.source_name
    }
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="less">
.opallbox{
  padding: 20px 20px 0px 20px;
  display: flex;
  flex-wrap: wrap;
}

.optionbox{
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 15px;
}
.optiontext{
  margin-right: 10px;
  font-size: 14px;
  flex-shrink: 0;
}
.editbox{
  /* padding: 0 20px 0px 20px; */
  display: flex;
}
.leftbox{
  width: 403px;
}
.addbox{
  width: 403px;
  height: 48px;
  border: 1px solid #f3f3f3;
  text-align: center;
  line-height: 48px;
  position: relative;
}
.updatabox{
  height: 158px;
  text-align: center;
  line-height: 158px;
  border: 1px solid #f3f3f3;
  position: relative;
}
.updatabox1{
    position: relative;
    height: 72px;
    border: 1px solid #f3f3f3;
    padding: 0 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.srvbox{
  width: 50px;
  height: 40px;
}
.spanbox{
  position: absolute;
  left: 18px;
  z-index: 9;
  width: 350px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  padding-top: 30px;
  height: 130px;
  display: block;
  white-space: nowrap;

}
.spanbox1{
  position: inherit;
  left: 0;
  top: 0;
  width: 280px;
  z-index: 9;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tipbox{
  position: absolute;
  background: white;
  padding: 10px;
  position: absolute;
  top: 39px;
  left: 180px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.updataactive{
   border: 2px solid #07c160;
}
.centerbox{
  margin-left: 20px;
  width: 620px;
}
.centerinput{
  margin-top: 10px;
  margin-bottom: 20px;
}
.ciclebox{
  padding: 15px 7px 5px 7px;
  margin: 0 7px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 #e4e8eb;
  border-radius: 25px;
  position: absolute;
  left: 430px;
  top: 50%;
  transform: translate(0, -50%);
}
.tiparrowbox{
  display: flex;
  flex-direction: column;
}
.tipicon{
  margin-bottom: 5px;
}
.tipicon{
  font-size:20px ;
  margin-bottom: 10px;
}
.chooseicon{
  width: 90px;
      height: 90px;
    box-sizing: border-box;
    border: 2px dashed #ebebeb;
    text-align: center;
    padding-top: 12px;
    position: relative;
    flex-shrink: 0;
}
.iconplus{
  color: #8f9091;
  font-size: 20px;
}
.btn-text{
  font-size: 12px;
      color: #7e8081;
      margin-top: 10px;
}
.setting-group__title{
  font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
}
.backrbox{
width: auto;
    height: 100%;
  background-color: #e1e1e1;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.backrbox1{
    position: absolute;
    background-color: #e1e1e1;
        background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    top: 9px;
    right: 17px;
    width: 50px;
    height: 50px;
}
.select-cover__preview{
  position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.abstractbox{
  width: 100%;
  display: flex;
}
.textfield{
  margin-left: 10px;
  height: 100%;
}
.cropper-content .cropper {
        width: auto;
        height: 600px;
}

audio {
  width: 100%;
  height: 50px;
  outline: none;
  filter: none;
}
.viewrw{
  margin-top: 20px;
}
.btne{
  margin-top: 20px;
}
.sdawr{
  font-size: 15px;
  margin-right: 10px;
}
.fansbox{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.chawepalite{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.choosecover{
  display: flex;
  align-items: center;
}
 .editdraw /deep/ .el-drawer__body{
  height: 100%;
}
.bottom_box{
  height: 348px;
  width: 480px;
  overflow-y:scroll;
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}
.bottom_itembox{
  width: 220px;
  height: 90px;
  margin-right: 10px;
}
.bottom_qrcode{
  width: 616px;
  margin-bottom: 10px;
}
.bottom_Light{
  border: 2px solid #F56C6C;
}
.delter_icon{
  position: absolute;
  top: 9px;
  right: 10px;
}
.delter_icon i {
  font-size: 20px;
  cursor:pointer;
}
.outerLayer_mainArea{
    max-height: 550px;
    overflow-y: scroll;
   .mainArea_ul{
     display: flex;
     flex-wrap: wrap;
     padding: 0px;
     margin: 0px;
     .ul_li{
        width: 230px;
        height: 90px;
        box-shadow: 0px 0px 2px #888686;
        border-radius: 9px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        margin: 20px 5px;
        position: relative;

        .li_left{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 13px;
        }

        .li_right{
            display: flex;
            flex-direction: column;
            width: 60px;
            height: 100%;
            background-color: rgb(218, 218, 218);
            align-items: center;
            justify-content: space-around;
            font-size: 13px;
            .right_icon{
              font-size: 28px;
              cursor: pointer;
              color: #888686;
              &:hover{
                  color: black;
              }
            }
        }
        &.active{
           box-shadow: 0px 0px 5px #0fcf18;
          .implicit{
            display: flex;
          }
        }
        &:not(.active):hover{
          box-shadow: 0px 0px 5px #0fcf18;
          .implicit{
            display: flex;
          }
        }

        .implicit{
             position: absolute;
             width: 21px;
             height: 21px;
             border-radius: 50%;
             box-shadow: 0px 0px 2px black;
             display: none;
             align-items: center;
             justify-content: center;
             cursor: pointer;
             background-color: #fff;
             top: 2px;
             right: 2px;
             &:hover{
               box-shadow: 0px 0px 5px #0fcf18;
             }
             i{
               font-size: 18px;
             }
        }
     }
   }
 }
</style>
